module.exports = "/_next/static/images/AicpaSocBadge@2x-9403a05805728171f8b15a15eca31aba.png";